// Shared JSON fetcher for the Spoonacular API.
// Throws on HTTP errors and on Spoonacular failure bodies
// ({ status: "failure", ... }) so react-query surfaces a real error state
// instead of pages silently rendering empty content.
const fetchJson = async (url) => {
  const response = await fetch(url);

  let data = null;
  try {
    data = await response.json();
  } catch (e) {
    data = null;
  }

  if (!response.ok || (data && data.status === "failure")) {
    const message =
      (data && data.message) || `Request failed (${response.status})`;
    throw new Error(message);
  }

  return data;
};

export default fetchJson;
